import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { getUserId } from 'utils/storage';
import { type SurveyServiceTypes } from './types';

const SURVEYS_URL = `${BASE_URL}wellbeing/surveys`;

export const SurveyService: SurveyServiceTypes = {
  getUserSurveys: async surveyId =>
    service.get(`${SURVEYS_URL}/users/${getUserId()}`, { params: { type: surveyId } }),
  getSurveyResponses: async surveyId =>
    service.get(`${SURVEYS_URL}/${surveyId}/responses`, { params: { userId: getUserId() } }),
  getNextSurveyQuestions: async surveyId =>
    service.get(`${SURVEYS_URL}/${surveyId}/responses/next`, {
      params: { userId: getUserId() },
    }),
  saveSurveyResponse: async (surveyId, response) =>
    service.post(`${SURVEYS_URL}/${surveyId}/responses/answer`, response, {
      params: { userId: getUserId() },
    }),
  getSurveyHistory: async surveyId =>
    service.get(`${SURVEYS_URL}/${surveyId}/responses/history`, {
      params: { userId: getUserId() },
    }),
  getPatientSurveyHistory: async ({ userId, page = 0, size = 20, sort = 'completedAt,desc' }) =>
    service.get(`${SURVEYS_URL}/responses/history`, {
      params: { userId, page, size, sort },
    }),
  getPatientSurveyHistoryCount: async ({ userId }) =>
    service.get(`${SURVEYS_URL}/responses/history/count`, {
      params: { userId },
    }),
};
